import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import SummaryReadyComp from '../../../components/patientApp/patientChat/summary/summaryready';

const SummaryReady = () => {
    return <Background>
        <SummaryReadyComp />
    </Background>
}
export default SummaryReady;